import styled from "styled-components";
import { Tabs } from "antd";

export default styled( Tabs ) `
    
    //border-top: solid 1px #414141;


    &.ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar {
        height: 3px;
    }

    .back {
        cursor: pointer;
    }

    .deleteTab {
        color: rgba(225, 0, 26, 0.4);
        
        &:hover {
            color: rgba(225, 0, 26, 1);
        }
    }

    .ant-tabs-tab-disabled .deleteTab {
        color: rgba(225, 0, 26, 0.2);
        
        &:hover {
            color: rgba(225, 0, 26, 0.2);
        }
    }
    
`;
